<template>
  <div class="flex flex-col items-center justify-center text-center p-6">
    <div class="rounded-full border-[10px] border-red-50 bg-red-100 p-6 mb-6 shadow-sm shadow-red-100">
      <XCircle class="w-10 h-10 text-red-500" />
    </div>
    <h2 class="text-xl font-semibold text-gray-900 mb-2">{{ title }}</h2>
    <p class="text-sm text-gray-600 mb-6" v-html="message" />
    <button
      @click="onRestart"
      class="bg-primary text-white px-6 py-3 rounded-xl text-sm font-medium hover:bg-primary/90 hover:cursor-pointer transition shadow-sm shadow-primary/25"
    >
      Erneut laden
    </button>
  </div>
</template>

<script setup>
import { XCircle } from 'lucide-vue-next'

const props = defineProps({
  title: { type: String, default: 'Ein Fehler ist aufgetreten' },
  message: { type: String, default: 'Bitte versuche es später erneut.' }
})

const emit = defineEmits(['restart'])
function onRestart() {
  emit('restart')
}
</script>
